module.exports = __webpack_public_path__ + "img/dc255c9baa84c0fab3798f88bbb77794.2738908e.png";